<mat-form-field appearance="fill" floatLabel="always" class="partner-select">
  @if (label()) {
    <mat-label class="text-body text-neutral">{{ label() }}</mat-label>
  }

  <!--
    xemex-text-field was considered for the search input below but can't be used: it's a
    self-contained ControlValueAccessor with its own internal <input>, so there's no element to
    attach matInput / matAutocomplete / matChipInputFor to, and no way to host the chip grid. This
    field has to be a native <input> inside mat-form-field for the autocomplete and chips to work.
  -->
  @if (multiple()) {
    <mat-chip-grid #partnerChips>
      @for (partner of selectedPartners(); track partner.partnerOid) {
        <mat-chip-row (removed)="removePartner(partner)">
          {{ partner.partnerName }}
          <!--
            Bare <button> (not a xemex-*-button): the xemex button family is label-bearing
            (filled/tonal/outlined/text/link) with no icon-only variant, and matChipRemove must sit
            on the button element itself — it can't reach the inner button a xemex wrapper renders.
          -->
          <button matChipRemove [attr.aria-label]="'Remove ' + partner.partnerName">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      type="text"
      [formControl]="partnerSearchControl"
      [placeholder]="placeholder()"
      [matChipInputFor]="partnerChips"
      [matAutocomplete]="partnerAuto"
      (focus)="onFocus()"
    />
  } @else {
    <input
      type="text"
      matInput
      [formControl]="partnerSearchControl"
      [placeholder]="placeholder()"
      [matAutocomplete]="partnerAuto"
      (focus)="onFocus()"
    />
  }

  <!--
    Must be the sole node of its control-flow block: a block with multiple root nodes can't project
    a node into the form field's suffix slot (NG8011), so the suffix would fall through to the
    default infix slot and render below the input instead of inline.

    Bare mat-icon-button (not a xemex-*-button): no xemex variant is icon-only, and matIconSuffix
    has to be on the button element itself to project into the form field's suffix slot — wrapping
    it in a xemex button would neither match the icon-only style nor wire the suffix correctly.
  -->
  @if (!multiple() && singleSelected() && !disabled()) {
    <button
      matIconSuffix
      mat-icon-button
      type="button"
      [attr.aria-label]="'general.btnClear' | translate"
      (click)="clearSingle()"
    >
      <mat-icon>close</mat-icon>
    </button>
  }

  <mat-autocomplete #partnerAuto="matAutocomplete" (optionSelected)="onPartnerSelected($event)">
    @if (companyStore.isSearchingPartners()) {
      <mat-option disabled>{{ 'general.searchingPartners' | translate }}</mat-option>
    } @else if (hasPartnerQuery && companyStore.partnerSearchResults().length === 0) {
      <mat-option disabled>{{ 'general.noPartnersFound' | translate }}</mat-option>
    } @else {
      @for (partner of partnerOptions(); track partner.partnerOid) {
        <mat-option [value]="partner">{{ partner.partnerName }}</mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
